import { Injectable } from '@angular/core';
import { BOONDOCK_SEARCH_API_URL, BoondockPoint, ListingPoint, SEARCH_API_URL, SearchQuery } from '@curbnturf/entities';
import { BoondockDbSet, CachedHttpClient, ListingDbSet } from '@curbnturf/network';
import { PlatformService } from '@curbnturf/network/src/lib/platform/platform.service';
import { combineLatest, from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(
    private http: CachedHttpClient,
    private boondockDbSet: BoondockDbSet,
    private listingDbSet: ListingDbSet,
    private platformService: PlatformService,
  ) {}

  find(query: SearchQuery): Observable<{ listings: ListingPoint[]; boondockListings: BoondockPoint[] }> {
    const queryObject = new SearchQuery(query);

    return combineLatest([
      this.http.get<ListingPoint[]>(`${SEARCH_API_URL}?${queryObject.toString()}`, undefined, {
        offlineCallback: () => this.retrieveListingCached(query),
        syncAction: { type: '' }, // @todo create sync action
      }),
      this.http.get<BoondockPoint[]>(`${BOONDOCK_SEARCH_API_URL}?${queryObject.toString()}`, undefined, {
        offlineCallback: () => this.retrieveBoondockCached(query),
        syncAction: { type: '' }, // @todo create sync action
      }),
    ]).pipe(
      map((results) => {
        return { listings: results[0], boondockListings: results[1] };
      }),
    );
  }

  private retrieveListingCached(query: SearchQuery): Observable<ListingPoint[]> {
    if (this.platformService.isPhysicalDevice()) {
      return from(this.listingDbSet.retrieveFiltered(query)).pipe(
        map((sites) => {
          return sites.map(
            (site) =>
              new ListingPoint({
                ...site,
              }),
          );
        }),
      );
    }

    return of([]);
  }

  private retrieveBoondockCached(query: SearchQuery): Observable<BoondockPoint[]> {
    if (this.platformService.isPhysicalDevice()) {
      return from(this.boondockDbSet.retrieveFiltered(query)).pipe(
        map((sites) => {
          return sites.map(
            (site) =>
              new BoondockPoint({
                ...site,
              }),
          );
        }),
      );
    }

    return of([]);
  }
}
